"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var KEYS = require('../../constants/keyCodes');

var AddressBarMiniToolbar = require('../icons/addressBarMiniToolbar.svg.js');

var BaseButton = require('../button/button');

var CancelSymbol = require('../x.svg.js');

var OkSymbol = require('../check.svg.js');

var TextInput = require('../textInput/textInput');

var isButton = function isButton(target) {
  if (target) {
    var predicate = function predicate(className) {
      return _.includes(['editable-url-btn-cancel', 'editable-url-btn-apply'], className);
    };

    return _.some(target.classList, predicate);
  }
};

var EditableUrl = /*#__PURE__*/function (_React$Component) {
  _inherits(EditableUrl, _React$Component);

  var _super = _createSuper(EditableUrl);

  function EditableUrl(props) {
    var _this;

    _classCallCheck(this, EditableUrl);

    _this = _super.call(this, props);
    _this.state = {
      isValid: true,
      isFocused: false,
      valueCandidate: props.value,
      isReadOnly: props.editButtons && !props.autoSelect || props.isReadOnly
    };

    _this.setStateWithReadOnly = function (nextIsReadOnly) {
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _.noop;
      var useNextIsReadOnly = _this.props.editButtons;

      var func = function func(_ref) {
        var isReadOnly = _ref.isReadOnly,
            isFocused = _ref.isFocused;
        var isReadOnlyState = {
          isReadOnly: useNextIsReadOnly ? nextIsReadOnly : isReadOnly,
          isFocused: nextIsReadOnly === true ? false : isFocused
        };
        return _.assign(isReadOnlyState, nextState);
      };

      _this.setState(func, callback);
    };

    _this.onChange = function () {
      _this.props.onChange(_this.state.valueCandidate);
    };

    _this.getClassNames = function () {
      var defaultName = 'control-editable-url';
      var focus = _this.state.isFocused ? ' focus' : '';
      var editButtons = _this.props.editButtons ? ' with-edit-buttons' : '';
      return _this.props.getClassName(defaultName + focus + editButtons);
    };

    _this.handleEdit = function () {
      _this.setStateWithReadOnly(false);

      _this.props.onEditClick();
    };

    _this.handleCandidateChange = function (valueCandidate) {
      var callback = _.partial(_this.props.onValueCandidateChange, valueCandidate);

      _this.setState({
        valueCandidate: valueCandidate
      }, callback);
    };

    _this.handleValidationStatusChange = function (isValid) {
      var callback = _.partial(_this.props.onValidationStatus, isValid);

      _this.setState({
        isValid: isValid
      }, callback);
    };

    _this.handleBlur = function (_ref2) {
      var relatedTarget = _ref2.relatedTarget;
      var validationOK = _this.state.isValid || _this.props.allowInvalidChange;
      var alreadyHandled = _this.alreadyHandled || isButton(relatedTarget);
      _this.alreadyHandled = false;

      _this.props.onBlur();

      if (!validationOK || alreadyHandled) {
        return;
      }

      if (_this.props.cancelOnBlur) {
        _this.handleCancel();
      } else if (_this.props.confirmOnBlur) {
        _this.handleConfirm();
      } else {
        _this.setStateWithReadOnly(true);
      }
    };

    _this.handleFocus = function () {
      _this.setState({
        isFocused: !_this.state.isReadOnly
      });
    };

    _this.handleCancel = function (blurInput) {
      var callback = function callback() {
        _this.onChange();

        if (_.isFunction(blurInput)) {
          _this.alreadyHandled = true;
          blurInput();
        }
      };

      var newState = {
        valueCandidate: _this.props.value,
        isValid: true
      };

      _this.setStateWithReadOnly(true, newState, callback);

      _this.props.onCancel();
    };

    _this.handleConfirm = function (blurInput) {
      var validationOK = _this.state.isValid || _this.props.allowInvalidChange;

      if (!validationOK) {
        return;
      }

      var callback = function callback() {
        _this.onChange();

        if (_.isFunction(blurInput)) {
          _this.alreadyHandled = true;
          blurInput();
        }
      };

      _this.setStateWithReadOnly(true, {}, callback);

      _this.props.onConfirm();
    };

    _this.handleKeyDown = function (_ref3, blur) {
      var keyCode = _ref3.keyCode;

      if (keyCode === KEYS.ENTER) {
        _this.handleConfirm(blur);
      } else if (keyCode === KEYS.ESC) {
        _this.handleCancel(blur);
      }
    };

    return _this;
  }

  _createClass(EditableUrl, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          valueCandidate: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.getClassNames()
      }, /*#__PURE__*/React.createElement("div", {
        className: "address-bar-container"
      }, /*#__PURE__*/React.createElement(AddressBarMiniToolbar, null), /*#__PURE__*/React.createElement("div", {
        className: "url-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "domain",
        onClick: this.props.onDomainClick
      }, this.props.domain), /*#__PURE__*/React.createElement(TextInput, {
        defaultInputClass: "input-editable-url",
        focus: false,
        onClick: this.props.onInputClick,
        isReadOnly: this.state.isReadOnly,
        value: this.state.valueCandidate,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        closeTooltipOnClickOutside: this.props.closeTooltipOnClickOutside,
        blurOnEscKey: false,
        blurOnEnterKey: false,
        autoSelect: this.props.autoSelect,
        onChange: this.handleCandidateChange,
        onValidationStatus: this.handleValidationStatusChange,
        onFocus: this.handleFocus,
        selectOnFocus: false,
        shouldTranslate: this.props.shouldTranslate,
        allowInvalidChange: true,
        validator: this.props.validator,
        isValid: this.props.isValid,
        invalidMessage: this.props.invalidMessage,
        syncDelay: this.props.syncDelay,
        tooltipInteractive: this.props.tooltipInteractive,
        preventBlur: !this.state.isValid && !this.props.allowInvalidChange,
        placeholder: this.props.placeholder
      }))), this.props.editButtons ? /*#__PURE__*/React.createElement("div", {
        className: "buttons-container",
        key: "buttonsContainer"
      }, this.state.isReadOnly ? null : /*#__PURE__*/React.createElement(BaseButton, {
        className: "btn-light btn-md btn-round editable-url-btn-cancel",
        onClick: this.handleCancel,
        key: "cancel"
      }, /*#__PURE__*/React.createElement(CancelSymbol, null)), this.state.isReadOnly ? null : /*#__PURE__*/React.createElement(BaseButton, {
        disabled: !this.state.isValid && !this.props.allowInvalidChange,
        className: "btn-light btn-md btn-round editable-url-btn-apply",
        onClick: this.handleConfirm,
        key: "ok"
      }, /*#__PURE__*/React.createElement(OkSymbol, null)), this.state.isReadOnly ? /*#__PURE__*/React.createElement(BaseButton, {
        className: "btn-light btn-edit",
        onClick: this.handleEdit,
        key: "edit",
        ellipsis: true
      }, this.props.translateIfNeeded(this.props.editButtonText)) : null) : null);
    }
  }]);

  return EditableUrl;
}(React.Component);

var validatorType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.func]);
EditableUrl.displayName = displayNames.EDITABLE_URL;
EditableUrl.propTypes = {
  domain: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onValueCandidateChange: PropTypes.func,
  editButtons: PropTypes.bool,
  editButtonText: function editButtonText(props, propName, componentName) {
    if (!props[propName] && props.editButtons) {
      return new Error("Required prop '".concat(propName, "' was not specified in '").concat(componentName, "'."));
    }
  },
  autoSelect: PropTypes.bool,
  confirmOnBlur: PropTypes.bool,
  cancelOnBlur: PropTypes.bool,
  placeholder: PropTypes.string,
  validator: validatorType,
  invalidMessage: PropTypes.node,
  tooltipInteractive: PropTypes.bool,
  closeTooltipOnClickOutside: PropTypes.bool,
  onValidationStatus: PropTypes.func,
  allowInvalidChange: PropTypes.bool,
  syncDelay: PropTypes.number,
  isValid: PropTypes.bool,
  onDomainClick: PropTypes.func,
  onInputClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};
EditableUrl.defaultProps = {
  isReadOnly: false,
  value: '',
  onChange: _.noop,
  onBlur: _.noop,
  onValueCandidateChange: _.noop,
  editButtons: false,
  autoSelect: true,
  confirmOnBlur: true,
  cancelOnBlur: false,
  closeTooltipOnClickOutside: true,
  onValidationStatus: _.noop,
  placeholder: '',
  onDomainClick: _.noop,
  onInputClick: _.noop,
  onEditClick: _.noop,
  onCancel: _.noop,
  onConfirm: _.noop
};
module.exports = compose(EditableUrl);